import {
    EVENTS_TEMPLATES_FETCH_LIST_REQUEST,
    EVENTS_TEMPLATES_FETCH_LIST_FAILURE,
    EVENTS_TEMPLATES_FETCH_LIST_SUCCESS,
    EVENTS_TEMPLATES_FETCH_REQUEST,
    // EVENTS_TEMPLATES_FETCH_FAILURE,
    EVENTS_TEMPLATES_FETCH_SUCCESS,
    EVENTS_TEMPLATES_TAGS_FETCH_REQUEST,
    // EVENTS_TEMPLATES_TAGS_FETCH_FAILURE,
    EVENTS_TEMPLATES_TAGS_FETCH_SUCCESS,
    EVENTS_TEMPLATES_TOURS_FETCH_REQUEST,
    // EVENTS_TEMPLATES_TOURS_FETCH_FAILURE,
    EVENTS_TEMPLATES_TOURS_FETCH_SUCCESS,
    EVENTS_TEMPLATES_SET_REDIRECT_URL,
    EVENTS_TEMPLATES_SET_CLUB_ID,
} from '../actions/actionTypes/event-template-action-types';

const initialState = {
    templates: [],
    templatesFetchState: {
        loading: false,
        loaded: false,
        count: 100,
        total: 0,
        fetched: 0,
    },
    currentTemplate: null,
    tags: [],
    tours: [],
    redirectUrl: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case EVENTS_TEMPLATES_FETCH_LIST_REQUEST:
            return {
                ...state,
                templates: action.initialFetch ? [] : state.templates,
                templatesFetchState: {
                    ...state.templatesFetchState,
                    loading: true,
                    loaded: false,
                    error: null,
                    total: action.initialFetch ? 0 : state.templatesFetchState.total,
                    fetched: action.initialFetch ? 0 : state.templatesFetchState.fetched,
                },
            };
        case EVENTS_TEMPLATES_FETCH_LIST_FAILURE:
            return {
                ...state,
                templatesFetchState: {
                    ...state.templatesFetchState,
                    loading: false,
                    loaded: true,
                    error: 'Error getting templates list',
                },
            };
        case EVENTS_TEMPLATES_FETCH_LIST_SUCCESS:
            return {
                ...state,
                templates: [
                    ...state.templates,
                    ...action.data.results,
                ],
                templatesFetchState: {
                    ...state.templatesFetchState,
                    loading: false,
                    loaded: true,
                    error: null,
                    total: action.data.totalCount,
                    fetched: (state.templatesFetchState.fetched + action.data.results.length),
                },
            };
        case EVENTS_TEMPLATES_FETCH_REQUEST:
            return {
                ...state,
                currentTemplate: null,
            };
        case EVENTS_TEMPLATES_FETCH_SUCCESS:
            return {
                ...state,
                currentTemplate: action.data,
            };
        case EVENTS_TEMPLATES_TAGS_FETCH_REQUEST:
            return {
                ...state,
                tags: [],
            };
        case EVENTS_TEMPLATES_TAGS_FETCH_SUCCESS:
            return {
                ...state,
                tags: action.data,
            };
        case EVENTS_TEMPLATES_TOURS_FETCH_REQUEST:
            return {
                ...state,
                tours: [],
            };
        case EVENTS_TEMPLATES_TOURS_FETCH_SUCCESS:
            return {
                ...state,
                tours: action.data,
            };
        case EVENTS_TEMPLATES_SET_REDIRECT_URL:
            return {
                ...state,
                redirectUrl: action.data,
            };
        case EVENTS_TEMPLATES_SET_CLUB_ID:
            return {
                ...state,
                clubId: action.data,
            };
        default:
            return state;
    }
};
